import React from 'react';

const categoryIcons = {
  Economia: '📈',
  Política: '🏛️',
  Geopolítica: '🏛️',
  Esportes: '🏆',
  Esporte: '🏆',
  Tecnologia: '💻',
  Beleza: '💄',
  Famosos: '✨',
  Saúde: '🏥',
  Educação: '📚',
  Ciência: '🔬',
  Crimes: '🚨',
  Games: '🎮',
};

export default function Badge({ 
  category, 
  variant = 'default',
  className = '' 
}) {
  const baseStyles = 'inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-medium transition-colors';
  
  const variants = {
    default: 'bg-[var(--accent-soft)] text-[var(--accent)]',
    outline: 'border border-[var(--border)] text-[var(--text)]',
    muted: 'bg-[var(--card)] text-[var(--muted)]',
  };

  return (
    <span className={`${baseStyles} ${variants[variant]} ${className}`}>
      {categoryIcons[category] && <span>{categoryIcons[category]}</span>}
      <span>{category}</span>
    </span>
  );
}
